import React from "react";

const eventDetails = [
  {
    id: 1,
    snippet: "This event includes a fully catered three-course meal. See the menu options here.",
    fullText: (
      <React.Fragment>
        <p className={"test-full-name"}>Menu Options:</p>
        <div >
          <p>
            - STARTER -<br/>
            Bordeaux Country Tart with Onion & Goat’s Cheese:<br/>
            Golden French tart filled with sweet marmalade onions, balsamic roasted beets, semi dried tomato, rocket & goats’ cheese
          </p>
          <p>
            - MAINS (SELECT ONE) -<br/>
            1. Lamb Shank:<br/>
            A buttery experience of melt in your mouth lamb cooked in a sticky reduction of glazed broth on pillows of minted pea mashed potato, served with lots of soaking jus & scattered vegetables from the pot
          </p>
          <p>
            2. The West Coast:<br/>
            Griddle seared Cape linefish simply sprinkled with smoked sea salt, served on a limp garden spinach with butternut filled vegetables, Parisienne potato’s & a silky champagne cream sauce Potato & Vegetable “Bunny”
          </p>
          <p>
            3. Potato & Vegetable “Bunny”:<br/>
            A crisp skin hollowed baked potato, brimming with vegetables, chickpeas, lentils and grilled paneer, topped off with a fragrant Punjabi gravy - served with traditional raita, papadums & buttered naan
          </p>
          <p>
            - DESSERT -<br/>
            Love & Kisses:<br/>
            A trio of almond dipped profiterole filled with patisserie custard, brownie & toasted marshmallow
          </p>
        </div>
      </React.Fragment>
    ),
  },
  {
    id: 2,
    snippet: "Find out all of the details, including the fine print.",
    fullText: (
      <React.Fragment>
        <p className={"test-full-name"}>The Fine Print (served with love):</p>
        <div>
          <p>
            • Seating is at shared tables of 8. No private tables. This is a show meant to be shared.<br/><br/>
            • Tables are allocated on a first-come, first-served basis. Early bookers get the best seats in the house. Love favours the prepared.<br/><br/>
            • Main meals must be chosen when booking and can’t be changed on the night. Commit like it’s a Valentine.<br/><br/>
            • Starters and desserts are not pre-selected and can’t be swapped, unless allergies or intolerances are involved. Your comfort comes first.<br/><br/>
            • Tickets are non-refundable. If plans change, feel free to pass your ticket on to someone you adore.<br/><br/>
            • Cashless bar: cards only. Less fuss, more clinking glasses.
          </p>
        </div>
      </React.Fragment>
    ),
  },
  {
    id: 3,
    snippet: "Find out what is included in each couple's ticket.",
    fullText: (
      <React.Fragment>
        <p className={"test-full-name"}>Included for each couple:</p>
        <div>
          <p>
            Enter the Great Hall, and see it transformed into turn of the century Paris, for a show that is nothing short of Spectacular Spectacular.
          </p>
          <p>
            Each couple's ticket includes:
          </p>
          <p>
            • 3-course meal, with a selection of 3 different mains options.<br/><br/>
            • Valentines day show with music from Moulin Rouge.<br/><br/>
            • Fully catered venue bringing you into the world of Moulin Rouge Paris.<br/><br/>
            • Cashless bar for additional refreshments (charged separately).<br/><br/>
            • A night of romance you'll never forget!
          </p>
        </div>
      </React.Fragment>
    ),
  },
];

export default eventDetails;